import React, { useState } from "react";
import type { FAQ as FAQItem } from "../../data/landingData";

function SectionHeading({
    eyebrow,
    title,
    subtitle,
}: {
    eyebrow?: string;
    title: string;
    subtitle?: string;
}) {
    return (
        <div className="mx-auto mb-10 max-w-3xl text-center">
            {eyebrow ? (
                <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
                    <span className="h-2 w-2 rounded-full bg-white/60" />
                    {eyebrow}
                </div>
            ) : null}
            <h2 className="text-balance text-2xl font-semibold tracking-tight text-white sm:text-3xl">
                {title}
            </h2>
            {subtitle ? (
                <p className="mt-3 text-pretty text-sm text-white/70 sm:text-base">{subtitle}</p>
            ) : null}
        </div>
    );
}

export default function FAQ({ items }: { items: FAQItem[] }) {
    const [open, setOpen] = useState(0);

    return (
        <section id="faq" className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
            <SectionHeading
                eyebrow="FAQ"
                title="Najczęstsze pytania"
                subtitle="Jeśli chcesz, dorzucimy tu też linki do dokumentacji."
            />

            <div className="space-y-3">
                {items.map((it, idx) => {
                    const isOpen = idx === open;
                    return (
                        <div
                            key={it.q}
                            className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur"
                        >
                            <button
                                onClick={() => setOpen(isOpen ? -1 : idx)}
                                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                            >
                                <div className="text-sm font-semibold text-white">{it.q}</div>
                                <div className="text-white/50">{isOpen ? "—" : "+"}</div>
                            </button>
                            {isOpen ? (
                                <div className="px-5 pb-5 text-sm text-white/70">{it.a}</div>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
